<div class="flex flex-col layout">
  <div>
    <div class="flex flex-row justify-between">
      <div class="flex flex-row justify-between ml-32">
        <app-breadcrumb [items]="breadcrumbItems" class="mt-10 breadcrumb"></app-breadcrumb>
      </div>
      <!-- <div class="flex justify-end mr-24">
        <button class="flex btn-link fs-14 mt-6 fw-600 refresh-icon p-10 flex justify-center items-center h-32"
        (click)="refreshInstances();">
          <mat-icon svgIcon="refresh" class="mr-8 text-white" [@rotate]="count" (@rotate.done)="isLoading && count=count+1"></mat-icon>
          <div class="text-white">{{'INSTANCE_SUMMARY.REFRESH' | transloco}}</div>
        </button> -->
      <!-- </div> -->
    </div>
      <app-environment-header
      [data]="data" [isAWS]="isAWS" [isExternalTenant]="isExternalTenant" [tenantOriginChecked]="tenantOriginChecked" [getBlueprints]="getBlueprints" [releasePackage]="releasePackage" [serviceVersions]="serviceVersions" [tenantId]="tenantId" [tenantDetails]="tenantDetails" [isHeaderLoading]="isHeaderRefreshing || !getBlueprints" (instanceUpdated)="instanceUpdated()" (refreshRequested)="refreshFromHeader()" [configVersion]="configVersion" [sizingApplyInprogress]="sizingApplyInprogress" [subscriptionData]="subscriptionData">
      </app-environment-header>
    </div>
  @if(tenantOriginChecked) {
  <div class="flex flex-row fixed-layout">
    <div class="left-menu mt-16">
      <app-environment-sidebar (menuClick)="loadComponent($event)" [cloudProvider]="cloudProvider" [scheduleJobData] = "selectedScheduleJob" [data]="data" [serviceVersions]="serviceVersions" [isAWS]="isAWS" [isExternalTenant]="isExternalTenant"></app-environment-sidebar>
    </div>

    @if (showTourIntro) {
      <div class="tour-intro-backdrop" (click)="dismissNavTour()"></div>
      <div class="tour-intro-card">
        <div class="tour-intro-header">
          <span class="tour-intro-title">{{ 'TOUR.INTRO.TITLE' | transloco }}</span>
          <button class="tour-close-btn" (click)="dismissNavTour()" aria-label="Close">&#x2715;</button>
        </div>
        <p class="tour-intro-desc">{{ 'TOUR.INTRO.DESCRIPTION' | transloco }}</p>
        <div class="tour-intro-actions">
          <button class="btn-start-tour" (click)="startNavTour()">{{ 'TOUR.INTRO.START_TOUR' | transloco }}</button>
          <button class="btn-no-thanks" (click)="dismissNavTour()">{{ 'TOUR.INTRO.NO_THANKS' | transloco }}</button>
        </div>
      </div>
    }
    <div class="flex flex-col content ml-16 mr-16 mb-16 mt-16 w-100-percent fixed-content">
      @if (component === EnvironmentPages.OVERVIEW) {
        <app-environment-overview [solution]="service" [solutionVersion]="solutionVersion" [data]="data" [getBlueprints]="getBlueprints" [hasSecondaryRegion]="hasSecondaryRegion" (refreshInstance)="refreshFromOverview()" [isLoading]="isLoading" [count]="count"></app-environment-overview>
      } @else if(component === EnvironmentPages.SETTINGS) {
        <app-environment-settings [data]="data"></app-environment-settings>
      } @else if(component === EnvironmentPages.LOCAL_CONFIGURATION) {
        @if(showTableView === true) {
        <app-environment-local-configuration [data]="data" [currentConfigVersion]="configVersion" (updateEnvHeader)="instanceUpdated()"></app-environment-local-configuration>
        } @else if (showTableView === false){
        <app-environment-apply-local-config [data]="data" [fetchMigrateFailed]="fetchMigrateFailed" [isAWS]="isAWS"></app-environment-apply-local-config>
        } @else if(showTableView === null){
        <mat-card class="flex spinner-container">
          <mat-spinner diameter="24" color="primary" mode="indeterminate"></mat-spinner>
        </mat-card>
        }
      } @else if(component === EnvironmentPages.ENDPOINTS) {
        <app-environment-endpoints [data]="data" [isEndpointAvailable]="isEndpointAvailable" [accessTypeEndpoints]="accessTypeEndpoints" [exploreTypeEndpoints]="exploreTypeEndpoints" [configTypeEndpoints]="configTypeEndpoints" [otherTypeEndpoints]="otherTypeEndpoints" (copyEvent)="onCopyId($event)"></app-environment-endpoints>
      } @else if (component === EnvironmentPages.INVENTORY) {
        <app-environment-inventory [instanceId]="instanceId" [instance]="data" [isExternalTenant]="isExternalTenant"></app-environment-inventory>
      } @else if (component === EnvironmentPages.METRICS) {
        <app-environment-metrics [instanceId]="instanceId" [instance]="data"></app-environment-metrics>
      } @else if (component === EnvironmentPages.ACTIVITY) {
        <app-environment-activity [isExternalTenant]="isExternalTenant" (updateEnvHeader)="instanceUpdated()"></app-environment-activity>
      } @else if (component === EnvironmentPages.COMPONENT_UPDATE) {
        <app-environment-component-update></app-environment-component-update>
      } @else if (component === EnvironmentPages.CUSTOM_PACKAGE) {
        <app-environment-custom-package></app-environment-custom-package>
      } @else if(component === EnvironmentPages.DATABASE_BACKUP) {
      <app-environment-database-backup-component [data]="data"></app-environment-database-backup-component>
      } @else if(component === EnvironmentPages.SANITY_TEST) {
        <app-environment-sanity-test [data]="data"></app-environment-sanity-test>
      } @else if(component === EnvironmentPages.EF_TEST) {
        <app-environment-ef-test [data]="data"></app-environment-ef-test>
      } @else if(component === EnvironmentPages.COB) {
      <app-environment-cob [data]="data" [instance]="instance" [isAWS]="isAWS" [featuresMap]="featuresMap" [isCobLoaded]="isCobLoaded" [showLoader]="showLoader" [showSpinner]="showSpinner" [cobTable]="cobTable" [DeploymentClass]="DeploymentClass" [FeatureKeys]="FeatureKeys" [DeployStatus]="DeployStatus" (configureCob)="configureCob()" (onEditClick)="onEditClick($event.inputs, $event.action)"></app-environment-cob>
      }
      @if (component === EnvironmentPages.RELEASE_PACKAGE) {
        <app-environment-release-package [solution]="service" [solutionVersion]="solutionVersion" [data]="data" [getBlueprints]="getBlueprints" [isAWS]="isAWS"></app-environment-release-package>
      }
      @if (component === EnvironmentPages.PRODUCT_RVTS) {
        <app-environment-product-rvt [solution]="service" [solutionVersion]="solutionVersion" [data]="data" [getBlueprints]="getBlueprints"></app-environment-product-rvt>
      }
      @if (component === EnvironmentPages.SFTP) {
      <app-environment-sftp [solution]="service" [solutionVersion]="solutionVersion" [data]="data" [getBlueprints]="getBlueprints" [instanceFeatureResponse]="instanceFeatureResponse"></app-environment-sftp>
      }
      @if (component === EnvironmentPages.BASE_IMAGE) {
        <app-environment-base-image [instance]="data"></app-environment-base-image>
      }
      @if (component === EnvironmentPages.RUNBOOK) {
        <app-environment-runbook [instance]="data"></app-environment-runbook>
      }
      @if (component === EnvironmentPages.SCHEDULES) {
        <app-environment-schedule (goToJobs)="redirectToJobs($event)" [instance]="data" [data]="data"></app-environment-schedule>
      }
       @if (component === EnvironmentPages.JOBS) {
        <app-environment-jobs [data]="data" (clearAll)="clearData($event)" [scheduleJobData] = "selectedScheduleJob"></app-environment-jobs>
      }
      @if (component === EnvironmentPages.SIZING_DOCUMENTS) {
        <app-environment-sizing-documents [data]="data" (clearAll)="clearData($event)" (updateEnvHeader)="instanceUpdated()" (sizingApplyStatusChange)="sizingApplyInprogress = $event"></app-environment-sizing-documents>
      }
      @if (component === EnvironmentPages.UPDATE_MANAGER){
        <app-environment-update-manager></app-environment-update-manager>
      }
      @if (component === EnvironmentPages.DEPENDENCY_TREE) {
        <app-environment-dependency-tree [instanceId]="instanceId" [data]="data"></app-environment-dependency-tree>
      }
    </div>
  </div>
  } @else {
  <div class="flex skeleton-layout mt-30">
    <div class="left-column">
      <ngx-skeleton-loader appearance="line" count="4"></ngx-skeleton-loader>
    </div>
    <div class="right-column">
      <ngx-skeleton-loader appearance="line" count="1" [theme]="{ width: '200px' }"></ngx-skeleton-loader>
      <mat-divider class="w-100-percent mb-16 mt-8 divider-color"></mat-divider>
      <ngx-skeleton-loader appearance="line" count="1" [theme]="{ width: '280px' }"></ngx-skeleton-loader><br />
      <ngx-skeleton-loader appearance="line" count="1" [theme]="{ width: '450px' }"></ngx-skeleton-loader><br />
      <ngx-skeleton-loader appearance="line" count="1" [theme]="{ width: '280px' }"></ngx-skeleton-loader><br />
      <ngx-skeleton-loader appearance="line" count="1" [theme]="{ width: '540px' }"></ngx-skeleton-loader>
    </div>
  </div>
  }
</div>
